import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import EditorVMBase from 'Lib/Fs.SmartClient.Client/EditorVMBase';
import { PLATFORM } from 'aurelia-pal';
import FsUtility from '../../../Lib/Fs.SmartClient.Client/FsUtility';

@autoinject
@useView(PLATFORM.moduleName('Modules/Aqs/Components/PickDateDialogView.html'))
export default class PickDateDialogVM {

  FsUtility: FsUtility;
  controller: DialogController;
  btnclass: string = "btn btn-default";
  viewModel: EditorVMBase;
  view: string;
  Header: string;
  IsShowCancel: any;
  okbtnclass: string = "btn btn-default";
  cancelbtnclass: string = "btn btn-default";
  okbtn: string = "OK";
  cancelbtn: string = "Cancel";

  constructor(controller: DialogController) {
    this.controller = controller;
    this.FsUtility = Container.instance.get(FsUtility);
  }
  activate(data: any) {
    this.viewModel = data.viewModel;
    this.view = data.view;
    this.Header = data.Header;
    if (!(!data.okbtn || 0 === data.okbtn.length)) {
      this.okbtn = data.okbtn;
    }
    if (!(!data.okbtnclass || 0 === data.okbtnclass.length)) {
      this.okbtnclass = data.okbtnclass;
    }
    if (!(!data.cancelbtn || 0 === data.cancelbtn.length)) {
      this.cancelbtn = data.cancelbtn;
    }
    if (!(!data.cancelbtnclass || 0 === data.cancelbtnclass.length)) {
      this.cancelbtnclass = data.cancelbtnclass;
    }
  }

  Update() {
    var self = this;
    self.controller.ok(self.viewModel);
  }

  Cancel() {
    this.controller.cancel(this.viewModel);
  }

  Edit() {
    this.viewModel.BeginEdit();
  }
}
